import { Icon, InputNumber, Span } from "@goodfill/ui-components";
import { useState } from "react";

interface FieldProps {
  label: string;
  currentValue: string;
}

const Field: React.FC<FieldProps> = ({ currentValue, label }) => {
  return (
    <div className="flex flex-col">
      <Span font="medium">{label}</Span>
      <div className="flex items-center">
        <Span>{currentValue}</Span>
        <Icon name="pencil" />
      </div>
    </div>
  );
};

export const BankInformationSection: React.FC = () => {
  const [amount, setAmount] = useState(0);

  return (
    <div className="flex w-96">
      <div className="flex flex-col my-1 md:my-2 mx-4 md:mx-8 px-4 md:px-8 gap-4 md:gap-8">
        <div className="flex flex-col">
          <Field currentValue="Citibank NA" label="Bank Name" />
          <Field currentValue="12345678" label="Router Number" />
          <Field currentValue="12345678" label="Account Number" />
          <Field currentValue="Blake Smith" label="Account Name" />
        </div>

        <div className="flex">
          <Span>Funds available to withdraw</Span>
          <Span font="medium">TBD</Span>
        </div>

        <div className="flex flex-col">
          <Span font="medium">Amount to be Transferred</Span>
          <InputNumber
            min={0}
            value={amount}
            setValue={(value) => {
              if (value !== null) {
                setAmount(value);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
